// @givmo/board — the route miss, read as "not served here".
//
// A surface that is dark until the backend serves it (a calendar's, the year's annual disclosures')
// reads a 404 as the backend's own answer that the route is not served here, and renders today's page.
// Port-free on purpose: a director surface and an officer surface both ask it, and a director module
// may reach no officer port (`director/capacity-rail.test.ts`).

import { isGivmoError } from '@givmo/api-client';

/** Whether a failed read is the backend saying the route is not served here (dark, or absent). */
export function isNotServed(error: unknown): boolean {
  return isGivmoError(error) && error.status === 404;
}
